import type Highcharts from "highcharts";

import {
  greedyCullVisibleFlags,
  minPixelDistanceFromMarkerRadius,
} from "@/lib/graph/greedy-cull-by-pixel-distance";
import { nestChartRenderEvent } from "@/lib/graph/nest-chart-render-event";

function applyMarkerCullToChart(chart: Highcharts.Chart): boolean {
  const markerRadius = chart.options.plotOptions?.series?.marker?.radius || 4;
  const minPixelDistance = minPixelDistanceFromMarkerRadius(markerRadius);

  let shouldRedraw = false;

  chart.series.forEach((series) => {
    const nonEmptyPoints = series.points.filter(
      (point) => point.y !== null && point.y !== undefined,
    );

    const visible = greedyCullVisibleFlags(nonEmptyPoints, chart, minPixelDistance);

    nonEmptyPoints.forEach((point, index) => {
      const shouldEnable = visible[index];
      if (point?.options?.marker?.enabled !== shouldEnable) {
        point.update(
          {
            ...point.options,
            marker: { enabled: shouldEnable },
          },
          false,
          false,
        );
        shouldRedraw = true;
      }
    });
  });

  return shouldRedraw;
}

/** Appends marker density cull after any existing `chart.events.render`. */
export function withMarkerDensityCull(options: Highcharts.Options): Highcharts.Options {
  return nestChartRenderEvent(options, function (this: Highcharts.Chart) {
    const shouldRedraw = applyMarkerCullToChart(this);
    if (shouldRedraw) {
      this.redraw();
    }
  });
}
